import Modal from '@srm/ui/modal';
import { stopPointerDownBubble } from '@utils/stopPointerDownBubble';
import { useAvatarSrc } from './avatarUrl';

export interface IUserAvatarPreview {
    userKey?: string;
    name?: string;
    hasImage?: boolean;
    version?: number | string;
    photoVersion?: string;
}

interface IUserAvatarPreviewModalProps extends IUserAvatarPreview {
    onClose: () => void;
}

/** Монтируется владельцем просмотра, вне временного дропдауна карточки пользователя. Ключ фото владелец передаёт
 *  уже с учётом режима документа (в предпросмотре поддержки его нет). */
const UserAvatarPreviewModal = ({
    userKey,
    name,
    hasImage,
    version,
    photoVersion,
    onClose,
}: IUserAvatarPreviewModalProps) => {
    const src = useAvatarSrc(userKey, hasImage, photoVersion ?? version, 'full');

    return (
        // Портал остаётся потомком строки/ссылки по дереву React: клики в окне не должны включать навигацию строки.
        // Обёртка строчная: окно монтируется и внутри текста или ссылки.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <span style={{ display: 'contents' }} onClick={(event) => event.stopPropagation()}>
            <Modal onClose={onClose} header={name} size="content" closeOnEscape closeOnClickOutside>
                <div ref={stopPointerDownBubble} style={{ display: 'contents' }}>
                    {src ? (
                        <img
                            src={src}
                            alt={name}
                            style={{ display: 'block', width: 'min(80vw, 480px)', height: 'auto', borderRadius: 8 }}
                        />
                    ) : (
                        <div
                            style={{
                                width: 280,
                                height: 280,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            Загрузка…
                        </div>
                    )}
                </div>
            </Modal>
        </span>
    );
};

export default UserAvatarPreviewModal;
